"use client";
import AdvantageCardList from "@/components/advantageCard";
import { LBGhoverEffect } from "styles/hoverPresets";

const FeaturesComp = ({ items, columns = { base: 1, sm: 2, md: 4 } }) => {
  return (
    <AdvantageCardList
      items={items}
      hoverEffect
      hover={LBGhoverEffect}
      columns={columns}
    />
  );
};

export default FeaturesComp;
